import { usePersonalProfile } from '../entities/usePersonalProfile';
import { useProfile } from '../entities/useProfile';
import { useInstrumentWithDetails } from './useInstrumentWithDetails';

/** @category Instruments */
export function useDisplayCurrency(profileId?: string) {
  const personalProfile = usePersonalProfile();
  profileId = profileId || personalProfile?.id;
  const displayCurrencyCode = useProfile(profileId)?.displayCurrency;
  return useInstrumentWithDetails(
    { currencyCode: displayCurrencyCode },
    profileId,
  );
}
